import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import InternshipPage from './pages/InternshipPage';
import AboutPage from './pages/About'; // Import the AboutPage component
import ContactUs from './pages/ContactUs';
import Blog from './pages/Blog';
import DomainPage from './pages/DomainPage'; // Import the DomainPage component
import domainContent from './components/DomainContent'; // Import the domainContent object
import NotFoundPage from './pages/NotFoundPage'; // Import the NotFoundPage component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/internship" element={<InternshipPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/domain/:domain" element={<DomainPage domainContent={domainContent} />} />
        <Route path="/login" element={<NotFoundPage />} /> {/* Redirect login to 404 */}
        <Route path="*" element={<NotFoundPage />} /> {/* Default 404 route */}
      </Routes>
    </Router>
  );
}

export default App;
